export default __webpack_public_path__ + "images/logo.6819e3.png";